<ion-avatar (click)="viewAction()">
  <img 
  [defaultImage]="assetLinksService.avatarLoading" 
  [lazyLoad]="outlet.image" 
  [errorImage]="assetLinksService.noImage"/>

</ion-avatar>
